export default __webpack_public_path__ + "6a316bcb4ad9eb0921aa8afa86042d84.png";